import '../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Catch-all 404 page. The SPA server still returns HTTP 200 for unknown
// routes, so the noindex meta (plus prerender-status-code for prerender
// services) is what keeps these URLs out of the index.
function NotFoundPage() {
    const {t: lnT} = useTranslation();

    return (
        <div style={{ maxWidth: 640, margin: '0 auto', padding: '96px 24px', textAlign: 'center' }}>
            <Helmet defer={false}>
                <title>{lnT('common:pageNotFoundLuckynote')}</title>
                <meta name="robots" content="noindex,nofollow" />
                <meta name="prerender-status-code" content="404" />
            </Helmet>
            <h1>{lnT('common:pageNotFound')}</h1>
            <p>{lnT('common:thePageYouReLookingForDoesn')}</p>
            <p>
                <Link to="/">{lnT('common:goToTheHomepage')}</Link> · <Link to="/blog">{lnT('common:readTheBlog')}</Link>
            </p>
        </div>
    );
}

export default NotFoundPage;
